import { render, staticRenderFns } from "./VouchersLanding.vue?vue&type=template&id=3f16eed2&"
import script from "./VouchersLanding.vue?vue&type=script&lang=js&"
export * from "./VouchersLanding.vue?vue&type=script&lang=js&"
import style0 from "./VouchersLanding.vue?vue&type=style&index=0&id=3f16eed2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports